import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerValidation } from '@inter-ikea-storageone/range';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import { doorOnCornerSolutionCanHaveHandles } from '../../utils/cornerSolution';
/**
 * Handles can only be added to one of the doors of a corner solution.
 * This should be on the door on the regular frame except if that door
 * is 25cm wide, then it should be on the door on the corner frame.
 */
export class RestrictHandlesOnCornerSolution extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictHandlesOnCornerSolution');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const host = snapActionCandidate.host;
        const guest = snapActionCandidate.guestRoot;
        const doorOnCornerSolution = !!HierarchyUtils.findInUpwardsHierarchy(host, entity => entity.hasComponent(CornerSolutionComponent.id));
        if (!guest.hasComponent(ComponentIds.HANDLE_COMPONENT_ID) ||
            !host.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID) ||
            !doorOnCornerSolution) {
            return this.validationOK();
        }
        return doorOnCornerSolutionCanHaveHandles(host, this.coreApi)
            ? this.validationOK()
            : this.validationFail('Handle cannot be placed on this door in corner solution');
    }
}
//# sourceMappingURL=RestrictHandlesOnCornerSolution.js.map